export const prefix = 'flowchart-editor';
export const FormItemHeight = 24;
